export interface DocumentDefinition {
	document: string;
	id?: number;
	signatureType: SignatureType;
	title: string;
	signatureText: string;
	descriptor: string;
	fileType: DocumentFileType;
}

export enum SignatureType {
	none = 0,
	signature = 1,
	check = 2,
}

export enum DocumentFileType {
	html = 1,
	pdf = 2,
}
